import { Header, Input, Icon } from "semantic-ui-react";
// import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination/Pagination.js";
import { TableComponent } from "../../../components/Table/table.js";
import ActionDropdown from "../../../components/ActionDropdown/ActionDropdown.js";
import Loading from "../../../components/Loading/Loading.js";
import { api } from "../../../api/api.js";
import moment from "moment";
// import { ReactComponent as EditIcon } from "../../../images/edit.svg";
// import { ReactComponent as EyeIcon } from "../../../images/eye.svg";
import DeleteConfirmModal from "../../../components/ActionDropdown/DeleteConfirmModal.js";
import axios from "axios";
import { gseller_url, seller_url } from "../../../api/urls.js";
import MoreInfoModal from "./more_info_modal.js";
import unknownError from "../../../utils/unknownError.js";
import { na2 } from "../../../utils/na.js";
import { bool } from "../../../utils/bool.js";
import BackButton from "../../../components/BackButton/BackButton.js";
import { modules, perms } from "../../../api/codes.js";
import { ProtectedElement } from "../../../components/ProtectedElement/ProtectedElement.js";
import { DashboardImage } from "../../../components/DashboardImage/DashboardImage.js";
import { useModal } from "../../../components/Modaler";
import { useToast } from "../../../components/Toast";

const Sellers = ({ isGlobal }) => {
  const apiUrl = isGlobal ? gseller_url : seller_url;

  const title = "Sellers";
  // const currentRoute = "sellers";
  const searchFeild = "company_name";
  const module = isGlobal ? modules.GlobalSeller : modules.Seller;
  const headers = [
    "Company image",
    "Seller name",
    "Company name",
    "Is verified",
    "Update date",
    "Update by",
    "Status",
    "Actions",
  ];
  const bodyMap = (d, refetch, isGlobal, apiUrl) => {
    return [
      <>
        <DashboardImage
          src={d.company_image}
          height="70px"
          width="70px"
          circle
        />
        <MoreInfoModal data={d} refetch={refetch} isGlobal={isGlobal} />
      </>,
      na2(
        d.firstname && d.lastname,
        <div className="wrap">{d.firstname + " " + d.lastname}</div>
      ),
      <div className="wrap">{d.company_name}</div>,
      <div className="center">{bool(d.is_verified)}</div>,
      moment(d.updated_at).format("DD-MM-YYYY"),
      "Admin",
      <div className={d.is_active ? "active-green" : "active-red"}>
        {d.is_active ? "Active" : "Inactive"}
      </div>,
      <ActionDropdown
        DeleteButton={({ setOpen }) => (
          <DeleteConfirmModal
            data={d}
            dropdownCloser={() => setOpen(false)}
            route={apiUrl}
            module={module}
            setTableData={() => refetch()}
          />
        )}
        options={(closer) => (
          <ProtectedElement module={module} perm={perms.edit}>
            <div
              className="option"
              onClick={() => {
                closer();
                modaler.opener(
                  <ChangeSellerStatus
                    d={d}
                    refetch={refetch}
                    closer={() => modaler.closer()}
                    apiUrl={apiUrl}
                  />,
                  false
                );
              }}
            >
              <div className="purple-title">
                {d.is_active ? "Make inactive" : "Make active"}
              </div>
            </div>
          </ProtectedElement>
        )}
      />,
    ];
  };

  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [refetcher, setRefetcher] = useState(false);

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState();

  const modaler = useModal();

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getData = async () => {
      setData();
      try {
        const res = await api.get(
          apiUrl + "?limit=" + limit + "&offset=" + offset,
          { cancelToken: source.token }
        );
        setData(res.data);
        setCount(res.data.count);
      } catch (err) {
        unknownError(err);
      }
    };
    getData();
    return () => {
      source.cancel();
    };
  }, [refetcher, limit, offset, apiUrl]);

  const refetch = () => {
    setRefetcher((v) => !v);
  };

  return (
    <>
      <BackButton />
      <div id="heading">
        <Header>{title}</Header>
        <div className="right">
          <Input
            type="text"
            placeholder="Company"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            icon={<Icon name="search" link id="search-icon" />}
          />
          {/* <ProtectedElement module={module} perm={perms.add}>
            <Link to={currentRoute + "/new"}>
              <button className="btn">Add New</button>
            </Link>
          </ProtectedElement> */}
        </div>
      </div>
      {data ? (
        <>
          <TableComponent
            headers={headers}
            body={
              data.results
                ? data.results
                    .filter((d) =>
                      d[searchFeild]
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    )
                    .map((d) => {
                      return bodyMap(d, refetch, isGlobal, apiUrl);
                    })
                : []
            }
            showbottom={false}
            disableHeaderPopup
          />
        </>
      ) : (
        <Loading />
      )}
      {count ? (
        <Pagination count={count} setLimit={setLimit} setOffset={setOffset} />
      ) : null}
    </>
  );
};

function ChangeSellerStatus({ d, refetch, closer, apiUrl }) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  return (
    <div style={{ padding: "40px" }}>
      <div style={{ fontSize: "20px", fontWeight: "500" }}>Are you sure?</div>
      <div style={{ padding: "20px" }} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <button
          className="btn-red"
          onClick={() => {
            closer();
          }}
        >
          No
        </button>
        <button
          className="btn"
          disabled={loading}
          onClick={async () => {
            setLoading(true);
            try {
              await api.patch(apiUrl + d.id + "/", {
                is_active: !d.is_active,
              });
              closer();
              refetch();
              toast.open("Status changed successfully", "success");
            } catch (e) {
              unknownError(e);
            }
            setLoading(false);
          }}
        >
          Yes
        </button>
      </div>
    </div>
  );
}

export default Sellers;
